// promotion/promotion.schema.ts
import { z } from "zod";
var DbBrandPromotionSchema = z.object({
  id: z.string().uuid(),
  brand_id: z.string().uuid(),
  brand_name: z.string(),
  headline: z.string(),
  story_text: z.string(),
  hero_image_url: z.string(),
  cta_text: z.string(),
  is_active: z.boolean(),
  priority: z.number(),
  starts_at: z.union([z.string(), z.date()]).nullable(),
  ends_at: z.union([z.string(), z.date()]).nullable(),
  domain_scope: z.string().nullable(),
  created_at: z.union([z.string(), z.date()]),
  updated_at: z.union([z.string(), z.date()])
});
var BrandPromotionSchema = z.object({
  id: z.string().uuid(),
  brandId: z.string().uuid(),
  brandName: z.string(),
  headline: z.string(),
  storyText: z.string(),
  heroImageUrl: z.string(),
  ctaText: z.string(),
  isActive: z.boolean(),
  priority: z.number(),
  startsAt: z.date().nullable(),
  endsAt: z.date().nullable(),
  domainScope: z.string().nullable(),
  createdAt: z.date(),
  updatedAt: z.date()
});
var BrandPromotionSpotlightDtoSchema = z.object({
  id: z.string(),
  brandId: z.number(),
  brandName: z.string(),
  headline: z.string(),
  storyText: z.string(),
  heroImageUrl: z.string(),
  ctaText: z.string()
});
var BrandPromotionDtoSchema = z.object({
  id: z.string(),
  brandId: z.string(),
  brandName: z.string(),
  headline: z.string(),
  storyText: z.string(),
  heroImageUrl: z.string(),
  ctaText: z.string(),
  isActive: z.boolean(),
  priority: z.number(),
  startsAt: z.string().nullable(),
  endsAt: z.string().nullable(),
  domainScope: z.string().nullable(),
  createdAt: z.string(),
  updatedAt: z.string()
});
var BrandCarouselItemDtoSchema = z.object({
  id: z.string(),
  brandId: z.string().uuid(),
  b2bwaveBrandId: z.number().nullable(),
  brandName: z.string(),
  heroImageUrl: z.string(),
  brandLogoUrl: z.string().nullable()
});
var CreateBrandPromotionDtoSchema = z.object({
  brandId: z.string().uuid(),
  brandName: z.string().min(1),
  headline: z.string().min(1),
  storyText: z.string().min(1),
  heroImageUrl: z.string().min(1),
  ctaText: z.string().optional().default("Explore"),
  isActive: z.boolean().optional().default(true),
  priority: z.number().optional().default(0),
  startsAt: z.string().nullable().optional(),
  endsAt: z.string().nullable().optional(),
  domainScope: z.string().nullable().optional()
});
export {
  BrandCarouselItemDtoSchema,
  BrandPromotionDtoSchema,
  BrandPromotionSchema,
  BrandPromotionSpotlightDtoSchema,
  CreateBrandPromotionDtoSchema,
  DbBrandPromotionSchema
};
